import React from 'react'

import { Box, Text } from 'grommet'
import { useNavigate } from 'react-router-dom'



import FontAwesome from '../../../components/compound/fontAwesome/FontAwesome'

import LocalStorageService from '../../../services/LocalStorageService'
import { useEffect, useState } from 'react'
import ActionButton from '../../../components/compound/actionButton/ActionButton'

const PlanLinkBar = (props) => {
  // replace the name of the service user with the stored term
  const terms = LocalStorageService.get('terms')
  const activeOrg = LocalStorageService.get('activeOrg') 
  const user = LocalStorageService.get('userDetails')

  const navigate = useNavigate()

  const [links, setLinks] = useState([])

  useEffect(() => {
    let newLinks = [
        {
            href: '/plans',
            icon: ['fal', 'clipboard-list-check'],
            title: 'My Smart Plans',
        },
        {
            href: '/behaviour/drafts',
            icon: ['fal', 'pencil'],
            title: 'Incomplete Smart Plans',
        }
    ]    
    setLinks(newLinks)
    
  }, [])



//   window.location.pathname

  return (
    <Box background='white' direction='column' gap='small' margin={{ bottom: 'medium' }} round='small' flex='grow'>
        <Box direction='row-responsive' justify='start' pad={{ horizontal: 'medium', vertical: 'small' }}>
        <Box alignSelf='center' direction='row-responsive' gap='xsmall'>
            {links.map((link, index) => (
                <ActionButton secondary={link.href !== window.location.pathname} primary={link.href === window.location.pathname} label={<Text size='medium'><FontAwesome icon={link.icon} /> {link.title}</Text>} margin={{ horizontal: 'xsmall' }} pad={{ horizontal: 'xsmall' }} onClick={() => navigate(link.href)} target='_self' />)
            )}
        </Box>
        </Box>
    </Box>
  )
}



export default PlanLinkBar



